function convertMongodbObjectsToStrings(obj) {
    if (obj == null || typeof obj !== 'object') {
        return obj;
    }

    // Check for BSON types via _bsontype property
    if (obj._bsontype) {
        switch (obj._bsontype) {
            case 'ObjectId':
            case 'Binary':
            case 'Decimal128':
                return obj.toString();
            case 'Date':
                // MongoDB dates are already JS Date objects
                return obj.toISOString();
            default:
                // Handle other BSON types generically
                return obj.toString();
        }
    }

    // Handle regular Date objects (in case they're not BSON wrapped)
    // FYI - this is redundant if called from jsonPatchRfc6902v3 with convertDatesToStrings first
    // leaving it in for safety since this is a standalone utility
    if (obj instanceof Date) {
        return obj.toISOString();
    }

    // Recursively process arrays
    if (Array.isArray(obj)) {
        return obj.map(item => convertMongodbObjectsToStrings(item));
    }

    // Recursively process plain objects
    const result = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            result[key] = convertMongodbObjectsToStrings(obj[key]);
        }
    }
    return result;
}
exports.convertMongodbObjectsToStrings = convertMongodbObjectsToStrings;
